import dateFunctions from 'library/helpers/dateFunctions';
import useCleaningChecker from 'library/hooks/useCleaningChecker';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectCleaningConfigByOrg } from 'reduxStore/bookings/selectors';
import { Badge, Flex, Tag, Tooltip } from 'zui/Antd';

const CleaningStatusTag = ({ categoryID, color = 'blue' }) => {
	// Redux state
	const cleaningMap = useSelector(selectCleaningConfigByOrg);
	const timeFormat = 'DD MMM hh:mm A';

	// 2. Extract the specific cleaning configuration for the current category
	const cfg = cleaningMap?.[String(categoryID)] || null;

	// 3. Use the `useCleaningChecker` hook to handle the cleaning logic.
	// The hook checks the time against the cleaning window and updates every 60 seconds.
	const isCleaning = useCleaningChecker({
		cleaningConfig: cfg
	});

	// 4. If it's not a cleaning period or if there's no end time configured,
	// we don't render anything.
	if (!isCleaning || !cfg?.end) {
		return null;
	}

	// 5. Render the Tag when a cleaning period is active
	return (
		<Tooltip
			title={`App bookings are disabled in this area while Scheduled Cleaning is active (until ${dateFunctions
				.calculateDate(cfg.end)
				.format(timeFormat)}).`}
			styles={{
				body: {
					textAlign: 'center'
				}
			}}
		>
			<Tag color={color} style={{ borderWidth: 2 }}>
				<Flex align='center' gap={6}>
					{/* 🔄 Animated badge to indicate activity */}
					<Badge status='processing' color={color} />
					{/* 📅 Show end time in human-readable format */}
					{`Scheduled Cleaning until ${dateFunctions.calculateDate(cfg.end).format(timeFormat)}`}
				</Flex>
			</Tag>
		</Tooltip>
	);
};

export default CleaningStatusTag;
